export default {
  admin: [
    {
      icon: 'mdi-chart-bar',
      title: 'Beranda',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'home',
      to: { name: 'home' },
    },
    {
      icon: 'mdi-office-building',
      title: 'Organisasi',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'organisasi',
      to: { name: 'organisasi' },
      akses: 'organisasi.index',
    },
    {
      icon: 'mdi-store',
      title: 'Mitra',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'mitra',
      to: { name: 'mitra' },
      akses: 'mitra.index',
    },
    {
      icon: 'mdi-map-marker',
      title: 'Lokasi',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'lokasi',
      to: { name: 'lokasi' },
      akses: 'lokasi.index',
    },
    {
      icon: 'mdi-store',
      title: 'Loket',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'loket',
      to: { name: 'loket' },
      akses: 'loket.index',
    },
    {
      icon: 'mdi-view-dashboard',
      title: 'Item Karcis/Tiket',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'item',
      to: { name: 'item' },
      akses: 'item.index',
    },
    {
      icon: 'mdi-view-dashboard',
      title: 'Kategori',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'kategori',
      to: { name: 'kategori' },
      akses: 'kategori.index',
    },
    {
      icon: 'mdi-calendar-month',
      title: 'Operasional',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'kalender',
      to: { name: 'kalender' },
      akses: 'kalender.index',
    },
    {
      icon: 'mdi-account-tie',
      title: 'Petugas',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'petugas',
      to: { name: 'petugas' },
      akses: 'operator-loket.index',
    },
    {
      icon: 'mdi-hiking',
      title: 'Pemandu',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'pemandu',
      to: { name: 'pemandu' },
      akses: 'pemandu.index',
    },
    {
      icon: 'mdi-account-group',
      title: 'Admin',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'operator',
      children: [
        { title: 'Tenant', to: { name: 'operator-tenant' }, akses: 'operator-tenant.index' },
        { title: 'Organisasi', to: { name: 'operator-organisasi' }, akses: 'operator-organisasi.index' },
        { title: 'Lokasi', to: { name: 'operator-lokasi' }, akses: 'operator-lokasi.index' },
        { title: 'Koperasi', to: { name: 'operator-mitra' }, akses: 'operator-mitra.index' },
        // { title: 'Loket', to: { name: 'operator-loket' } },
      ],
    },
    {
      icon: 'mdi-file-document',
      title: 'Laporan',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'laporan',
      akses:
        'transaksi.index|laporan-pendapatan.index|laporan-pendapatan-qren.index|laporan-balai.index|billing-settlement.index',
      children: [
        { title: 'Semua Transaksi', to: { name: 'laporan-transaksi' }, akses: 'transaksi.index' },
        { title: 'Pendapatan', to: { name: 'laporan-pendapatan' }, akses: 'laporan-pendapatan.index' },
        {
          title: 'Pendapatan Non-Tunai : QREN',
          to: { name: 'laporan-pendapatan-qren' },
          akses: 'laporan-pendapatan-qren.index',
        },
        { title: 'Per Periode', to: { name: 'laporan-balai' }, akses: 'laporan-balai.index' },
        { title: 'Simponi TNK', to: { name: 'laporan-simponi' }, akses: 'laporan-balai.index' },
        { title: 'Settlement', to: { name: 'laporan-settlement' }, akses: 'billing-settlement.index' },
      ],
    },
    {
      icon: 'mdi-text-box-outline',
      title: 'Pendapatan',
      desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
      link: 'pendapatan',
      akses: 'transaksi-manual.index',
      children: [
        { title: 'Pencatatan', to: { name: 'pendapatan-transaksi' }, akses: 'transaksi-manual.index' },
        { title: 'Laporan', to: { name: 'pendapatan-laporan' }, akses: 'transaksi-manual.index' },
      ],
    },
    // {
    //   icon: 'mdi-history',
    //   title: 'Riwayat Aktivitas',
    //   desc: 'Lorem ipsum dolor si ametr jksadjkl phalesius protoiitote',
    //   link: 'logs',
    //   to: { name: 'logs' },
    // },
  ],
};
